import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { Shop } from '../../../models/vendor.model';
import { ShopCardComponent } from '../shop-card/shop-card.component';
import { ShopCardSkeletonComponent } from '../shop-card-skeleton/shop-card-skeleton.component';

@Component({
  selector: 'app-shop-section',
  standalone: true,
  imports: [CommonModule, RouterLink, ShopCardComponent, ShopCardSkeletonComponent],
  templateUrl: './shop-section.component.html',
  styleUrls: ['./shop-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShopSectionComponent {
  @Input({ required: true }) title!: string;
  @Input() icon = 'fa-store';
  @Input() viewAllLink: string | null = null;
  @Input() shops: Shop[] = [];
  @Input() loading = false;
  @Input() skeletonCount = 4;
  @Output() quickView = new EventEmitter<Shop>();

  @ViewChild('scrollRow') scrollRow!: ElementRef<HTMLElement>;

  get skeletons(): unknown[] {
    return Array.from({ length: this.skeletonCount });
  }

  scroll(direction: 'left' | 'right'): void {
    const el = this.scrollRow?.nativeElement;
    if (!el) return;
    const amount = el.clientWidth * 0.8;
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
  }

  trackById(_index: number, shop: Shop): number {
    return shop.id;
  }
}
